import React, { Component } from 'react';
import Link from 'react-router-dom/Link';
import './style.scss';

const MONTH_NAMES_FI = [
  'Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kes\u00e4kuu',
  'Hein\u00e4kuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'
];

function formatDateTime(isoDate, time) {
  const d = new Date(isoDate);
  return `${d.getDate()}. ${MONTH_NAMES_FI[d.getMonth()]} ${time}`;
}

class CourseCard extends Component {
  render() {
    const { course } = this.props;

    const startLabel = formatDateTime(course.course_date_iso, course.start_time);
    const endDateIso = course.end_date_iso || course.course_date_iso;
    const endLabel = formatDateTime(endDateIso, course.end_time);

    return (
      <div className="course-card">
        <div className="course-card__left">
          <div className="course-card__date">{course.course_date}</div>
          <div className="course-card__city">{course.city}</div>
          <div className="course-card__price">
            {course.price_euros.toFixed(0)} &euro;
          </div>
          <div className="course-card__vat">sis. alv 25,5 %</div>
        </div>

        <div className="course-card__main">
          <h4 className="course-card__name">{course.name}</h4>
          <div className="course-card__btn-area">
            {course.full ? (
              <span className="course-card__btn course-card__btn--disabled">TÄYNNÄ</span>
            ) : (
              <Link to={`/koulutus/${course.slug}`} className="course-card__btn">
                ILMOITTAUDU
              </Link>
            )}
          </div>
          <div className="course-card__details-row">
            <div className="course-card__detail">
              <i className="fa fa-clock-o"></i>
              <span>{startLabel} -<br />{endLabel}</span>
            </div>
            <div className="course-card__detail">
              <i className="fa fa-map-marker"></i>
              <span>{course.venue}{course.address ? `, ${course.address}` : ''}</span>
            </div>
          </div>
          <div className="course-card__spots">
            <i className="fa fa-user"></i>
            <span>{course.spots_taken} / {course.max_attendees}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default CourseCard;
